'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardSystemStats(system, total, sites) {
  this.Eo = null;
  this.Lo = 0;
  this.En = null;
  this.Eo = system;
  this.Lo = total;
  this.En = sites;
}
export { $c_Lpresto_types$DashboardSystemStats as $c_Lpresto_types$DashboardSystemStats };
$p = $c_Lpresto_types$DashboardSystemStats.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardSystemStats;
/** @constructor */
function $h_Lpresto_types$DashboardSystemStats() {
}
export { $h_Lpresto_types$DashboardSystemStats as $h_Lpresto_types$DashboardSystemStats };
$h_Lpresto_types$DashboardSystemStats.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("DashboardSystemStats"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Eo));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.Lo);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.En));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 3);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$DashboardSystemStats)) {
    if ((this.Lo === x$0.Lo)) {
      var x = this.Eo;
      var x$2 = x$0.Eo;
      var $x_1 = (x === x$2);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.En;
      var x$4 = x$0.En;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "DashboardSystemStats";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Eo;
      break;
    }
    case 1: {
      return this.Lo;
      break;
    }
    case 2: {
      return this.En;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$DashboardSystemStats(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jO)));
}
export { $isArrayOf_Lpresto_types$DashboardSystemStats as $isArrayOf_Lpresto_types$DashboardSystemStats };
var $d_Lpresto_types$DashboardSystemStats = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardSystemStats, "presto.types$DashboardSystemStats", ({
  jO: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$DashboardSystemStats as $d_Lpresto_types$DashboardSystemStats };
//# sourceMappingURL=presto.types$-Dashboard-System-Stats.js.map
